export default __webpack_public_path__ + "static/media/031-fishbowl.a9a0b421.svg";